// React i hooks
import { memo, useCallback, useState } from "react";

// Helpers
import { useTranslate } from "helpers";

// API i konstante
import { FleetWarehouseSearchFormValues } from "services/api/fleet/warehouses/types";
import { initialFleetWarehouseSearchForm } from "services/api/fleet/warehouses/consts";

// UI komponente
import { TextField } from "ui/components/TextField/TextField";

// Dropdown komponente

// Tipovi
import { WarehouseSearchFilterProps } from "./types";


const WarehouseSearchFilters: React.FC<WarehouseSearchFilterProps> = (
  props
) => {
  const { onSearchChange } = props;

  const { t } = useTranslate();

  const [formValues, setFormValues] = useState<FleetWarehouseSearchFormValues>(
    initialFleetWarehouseSearchForm
  );

  const handleSearchChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const updatedFormValues = { ...formValues, search: e.target.value };
    setFormValues(updatedFormValues);
    onSearchChange(updatedFormValues);
  };

  const handleResetFormClick = useCallback(() => {
    setFormValues(initialFleetWarehouseSearchForm);
  }, []);

  return (
    <>
      <div className="flex justify-between items-center ">
        <div className="flex flex-wrap gap-3">
          <div className="">
            <TextField
              type="text"
              name="search"
              value={formValues.search}
              onChange={handleSearchChange}
              placeholder={t("admin.search.placeholder")}
              startIcon="../media/icons/search.svg"
              cssClassName="bg-white"
            />
          </div>
          <div className="mr-3 md:mr-6 lg:md-12 flex items-center">
            <span
              onClick={handleResetFormClick}
              className="text-xs font-bold cursor-pointer text-gray-700"
            >
              {t("admin.reset")}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
export default memo(WarehouseSearchFilters);
